const Sentry = require('@sentry/browser');

export default function (app) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT
  });
  app.set('sentryClient', Sentry);
}
